/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { CurrentUser } from "src/classes/user";
import { Auth } from "src/classes/user/auth/Auth";

export const useCurrentUser = (): CurrentUser | null => {
  return Auth.instance.user;
};
